import React, { useRef, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  downloadRelatorioCsvCategoriasResumo,
  downloadRelatorioXlsxCategoriasResumo,
} from '../../../../api/contac/contacReportsCategoriasApi';
import FullScreenLoader from '../../../loading/FullScreenLoader';
import './ModalReports.css';
import '../filtro/ModalFiltro.css';
import '../../../../shared/ui/modal-close-button.css'; // X padrão do sistema

interface ModalReportsCategoriaProps {
  isOpen: boolean;
  onClose: () => void;

  initialCategoria?: string[];

  dataInicio: string;
  dataFim: string;
}

const ModalReportsCategoria: React.FC<ModalReportsCategoriaProps> = ({
  isOpen,
  onClose,
  initialCategoria = [],
  dataInicio,
  dataFim,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const [categoria, setCategoria] = useState<string[]>(initialCategoria);
  const [loading, setLoading] = useState(false);

  const CATEGORIAS: { value: string; label: string }[] = [
    { value: 'APLICATIVO DE MOBILIDADE URBANA', label: 'APP MOBILIDADE URBANA' },
    { value: 'AUTOMOVEL - ROUBO E FURTO', label: 'AUTOMÓVEL (ROUBO/FURTO)' },
    { value: 'CAMINHAO', label: 'CAMINHÃO' },
    { value: 'DIESEL LEVE', label: 'DIESEL LEVE' },
    { value: 'DIVERSOS', label: 'DIVERSOS' },
    { value: 'MOTO APP', label: 'MOTO APP' },
    { value: 'MOTOCICLETA', label: 'MOTOCICLETA' },
    { value: 'MOTO RISCO', label: 'MOTO RISCO' },
    { value: 'MOTOS ESPECIAIS', label: 'MOTOS ESPECIAIS' },
    { value: 'PASSEIO', label: 'PASSEIO' },
    { value: 'SEM CATEGORIA DEFINIDA', label: 'SEM CATEGORIA' },
    { value: 'TAXI', label: 'TÁXI' },
    { value: 'TAXI UBER', label: 'TÁXI UBER' },
    { value: 'UTILITARIO', label: 'UTILITÁRIO' },
  ];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  useEffect(() => {
    setCategoria(initialCategoria);
  }, [initialCategoria, isOpen]);

  if (!isOpen) return null;

  const toggleValue = (arr: string[], value: string) =>
    arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value];

  const formatarPeriodoCurto = (data: string) => {
    const meses = [
      'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
      'jul', 'ago', 'set', 'out', 'nov', 'dez',
    ];
    const [ano, mes] = data.split('-');
    return `${meses[Number(mes) - 1]}/${ano}`;
  };

  const handleDownload = async () => {
    try {
      setLoading(true);

      await downloadRelatorioCsvCategoriasResumo({
        dataInicio,
        dataFim,
        categorias: categoria.length > 0 ? categoria : undefined,
      });

      toast.success('Relatório CSV gerado com sucesso!');
      onClose();
    } catch {
      toast.error('Erro ao gerar CSV');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadXlsx = async () => {
    try {
      setLoading(true);

      await downloadRelatorioXlsxCategoriasResumo({
        dataInicio,
        dataFim,
        categorias: categoria.length > 0 ? categoria : undefined,
      });

      toast.success('Relatório XLSX gerado com sucesso!');
      onClose();
    } catch {
      toast.error('Erro ao gerar XLSX');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="modal-filtro-overlay">
        <div className="modal-filtro-content" ref={modalRef}>
          <div className="filtro-modal-card">
            
            {/* Header */}
            <div className="filtro-modal-header">
              <div>
                <h2 className="filtro-modal-title">Gerar Relatório de Categorias (Resumo)</h2>
                <p className="filtro-modal-subtitle">
                  {formatarPeriodoCurto(dataInicio)} – {formatarPeriodoCurto(dataFim)}
                </p>
              </div>
              <button className="close-button" onClick={onClose} disabled={loading}>&times;</button>
            </div>

            {/* Body */}
            <div className="filtro-modal-body">
              <div className="filtro-section">
                <h3 className="filtro-section-title">Selecione as Categorias (Opcional)</h3>
                
                <div className="lista-checkbox" style={{ marginTop: 8 }}>
                  {CATEGORIAS.map(({ value, label }) => (
                    <label key={value} className="checkbox-item" title={value}>
                      <input
                        type="checkbox"
                        checked={categoria.includes(value)}
                        disabled={loading}
                        onChange={() => setCategoria(toggleValue(categoria, value))}
                      />
                      <span className="checkbox-label">{label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="filtro-modal-footer">
              <button
                type="button"
                className="filtro-btn-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="filtro-btn-primary"
                onClick={handleDownload}
                disabled={loading}
              >
                {loading ? 'Gerando arquivo...' : 'Gerar CSV'}
              </button>
              <button
                type="button"
                className="filtro-btn-primary"
                onClick={handleDownloadXlsx}
                disabled={loading}
              >
                {loading ? 'Gerando arquivo...' : 'Gerar XLSX'}
              </button>
            </div>

          </div>
        </div>
      </div>

      {loading && <FullScreenLoader />}
    </>
  );
};

export default ModalReportsCategoria;
